import React, { useEffect, useState } from 'react';

import status0 from "../../assets/icons/icon-status-nao-enviado.png"
import status1 from "../../assets/icons/status-1.png"
import status2 from "../../assets/icons/icon-status-pending.png"
import status3 from "../../assets/icons/icon-status-enviado.svg"
import status4 from "../../assets/icons/icon-status-reload.png"

import * as S from './styles';
import { TaglinePSpan } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';

const ButtonWithTextAndStatus = ({ status, text, onClick, loading, disabled }) => {

  return (
    <S.Container status={status} onClick={disabled || loading ? undefined : onClick} style={{ opacity: loading || disabled ? 0.6 : 1, cursor: loading || disabled ? 'not-allowed' : undefined }}>
        <S.ContainerStatus>
            <img
                className={loading ? 'spinning' : ''}
                src={
                loading ? status4 :
                status === 0 ? status0 :
                status === 1 ? status3 :
                status === 2 ? status2 :
                status === 3 ? status4 : status0} alt="status" />
        </S.ContainerStatus>

        <TaglinePSpan 
            color={
                status === 0 ? theme.colors.red.Tostado : 
                status === 1 ? theme.colors.green.Folha :
                status === 2 ? theme.colors.yellow.Amarelo_atenção :
                status === 3 ? theme.colors.orange.Laranja : theme.colors.red.Vermelho_erro
            }>
                {text}
        </TaglinePSpan>
    </S.Container>
  );
};

export default ButtonWithTextAndStatus;
